import { render, staticRenderFns } from "./csr_dashboard.vue?vue&type=template&id=05a7cb8e&"
import script from "./csr_dashboard.vue?vue&type=script&lang=js&"
export * from "./csr_dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports